<ng-template #isEmpty>
  <ng-container *ngIf="PGB_VIEW_MODE">
    <div class="ds-info mb-3">
      {{ infoText }}
    </div>
    <fieldset>
      <legend i18n="@@customForms">Zusätzliche Eingabefelder</legend>
    </fieldset>
  </ng-container>
</ng-template>

<ng-container *ngIf="customForms$ | async as customForms">
  <ng-container *ngIf="customForms.length; else isEmpty">
    <ng-container
      *ngFor="let customForm of customForms; trackBy: trackByCustomFormId"
    >
      <fieldset *ngIf="customForm.fields.length; else isEmpty">
        <legend
          *ngIf="customForm.headline"
          [innerHTML]="customForm.headline"
        ></legend>

        <p
          *ngIf="customForm.description"
          class="mt-3 mb-4"
          [innerHTML]="customForm.description | sanitize : 'HTML'"
        ></p>

        <orderform-inputs-generator
          #fieldInput
          (dataChanges)="setData($event)"
          [data]="filledCustomForms$ | async"
          [fields]="customForm.fields"
          [attr.data-e2e]="'form:additional-inputs'"
        ></orderform-inputs-generator>
      </fieldset>
    </ng-container>
  </ng-container>
</ng-container>
